import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import {
	ICmmsFilterComponent,
	ICmmsFilterEmittedValue,
} from '@app/pages/cmms/components/cmms-sort-filters-grouping/cmms-applied-filters-bar/interfaces/filter-component.interface';
import { CmmsPages } from '@app/pages/cmms/state/cmms.reducer';
import { SelectionModel } from '@angular/cdk/collections';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatCheckboxChange, MatCheckbox } from '@angular/material/checkbox';
import { PRIORITY_LEVELS } from '@app/pages/cmms/configs/priority-levels';

import { AuPriorityLevelComponent } from '../../../../../../shared/ui-components/au-priority-level/au-priority-level.component';
import { NgxTolgeeModule } from '@tolgee/ngx';

export interface ICmmsFilterPriority {
	level: number;
	text: string;
}

@Component({
	selector: 'priority-filter',
	templateUrl: './priority-filter.component.html',
	styleUrls: ['./priority-filter.component.scss'],
	imports: [MatCheckbox, AuPriorityLevelComponent, NgxTolgeeModule],
})
export class PriorityFilterComponent implements ICmmsFilterComponent, OnInit, OnDestroy {
	@Input() data: {
		activePage: CmmsPages;
		preselectedValue: number[];
		columnName: string;
	};
	@Output() filterValueChanged = new EventEmitter<ICmmsFilterEmittedValue>();

	priorityList = PRIORITY_LEVELS;

	selectionModel = new SelectionModel<ICmmsFilterPriority>(true, []);

	private destroy$ = new Subject<void>();

	ngOnInit(): void {
		this.selectionModel.changed.pipe(takeUntil(this.destroy$)).subscribe(() => {
			this.filterValueChanged.emit(
				this.generateFilterValue(this.selectionModel.selected)
			);
		});

		setTimeout(() => {
			this.applyPreselectedValue();
		});
	}

	isChecked(priority: ICmmsFilterPriority): boolean {
		return this.selectionModel.isSelected(priority);
	}

	toggleSelection(evt: MatCheckboxChange, priority: ICmmsFilterPriority): void {
		if (evt.checked) {
			this.selectionModel.select(priority);
		} else {
			this.selectionModel.deselect(priority);
		}
	}

	private generateFilterValue(priorities: ICmmsFilterPriority[]): {
		columnName: string;
		label: string;
		data: number[];
	} {
		/* Label should be in specific format that is needed to show it in filter button. */
		const label = [];
		const data = [];

		priorities.forEach(priority => {
			label.push(priority.text);
			data.push(priority.level);
		});

		return {
			columnName: this.data.columnName,
			label: label.join('; '),
			data,
		};
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	private applyPreselectedValue() {
		if (this.data.preselectedValue?.length) {
			const arrayOfValues: { level: number; text: string }[] = this.priorityList.filter(
				option => this.data.preselectedValue.includes(option.level)
			);

			this.selectionModel.select(...arrayOfValues);
		}
	}
}
